import React, { useEffect } from "react";

import Aos from "aos";
import "aos/dist/aos.css";

const SkillsAndExperience = () => {
	useEffect(() => {
		Aos.init({
			duration: 1500,
			delay: 200,
			offset: 0,
			easing: "ease",
			once: true,
			mirror: false,
			disable: () => {
				return window.innerWidth < 600;
			},
		});

		window.scrollTo(0, 0);
	}, []);

	const skills = [
		{
			icon: "fab fa-vuejs",
			title: "Vue JS",
		},
		{
			icon: "fab fa-react",
			title: "React JS",
		},
		{
			icon: "far fa-keyboard",
			title: "Type Script",
		},
		{
			icon: "fab fa-sass",
			title: "SCSS",
		},
		{
			icon: "fas fa-exchange-alt",
			title: "Web Sockets",
		},
		{
			icon: "fas fa-tachometer-alt",
			title: "Web App Optimizations",
		},
		{
			icon: "fas fa-tools",
			title: "Problem Solving",
		},
		{
			icon: "fas fa-code",
			title: "Clean & DRY Code",
		},
	];

	const renderSkills = () => {
		const skillsArray = skills.map((skill) => {
			return (
				<div
					className="skill"
					data-aos="zoom-in"
					data-aos-delay="2000"
					key={skill.title}
				>
					<i className={skill.icon} />
					<div className="skill-label">{skill.title}</div>
				</div>
			);
		});

		return skillsArray;
	};

	return (
		<div className="skills-and-experience">
			<div className="skills-heading" data-aos="fade-down">
				Skills I Know
			</div>
			<div className="skills-container">
				<div
					className="skills"
					data-aos="zoom-in"
					data-aos-delay="1000"
				>
					{renderSkills()}
				</div>
			</div>
		</div>
	);
};

export default SkillsAndExperience;
